import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import NavigationPrompt from 'react-router-navigation-prompt';
import { Helmet } from 'react-helmet';

import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Card from '../../components/Card/Card';
import Error from '../../components/Error/Error';
import ProgressSteps from '../../components/ProgressSteps/ProgressSteps';
import Footer from '../../components/Footer/Footer';
import Dialog from '../../components/Dialog/Dialog';

import SessionStorage from '../../storage/SessionStorage/SessionStorage';

import Step1 from './Step1';
import Step2 from './Step2';

const getStepHandler = (nextHandler, backHandler, appState, api, update, history, validateCodeAndStoreSettings, validateCodeAndReturnRoute, generateURIFromCode, handleErrorMessage, handleMultipleAttempts, attempts, handleFormPrompt, form, handleCardStatus, url) => ({
  1: <Step1 nextHandler={nextHandler} backHandler={backHandler} appState={appState} api={api} update={update} history={history} validateCodeAndStoreSettings={validateCodeAndStoreSettings} validateCodeAndReturnRoute={validateCodeAndReturnRoute} generateURIFromCode={generateURIFromCode} handleErrorMessage={handleErrorMessage} handleMultipleAttempts={handleMultipleAttempts} attempts={attempts} handleFormPrompt={handleFormPrompt} form={form} handleCardStatus={handleCardStatus}/>,
  2: <Step2 nextHandler={nextHandler} backHandler={backHandler} appState={appState} api={api} update={update} history={history} generateURIFromCode={generateURIFromCode} handleErrorMessage={handleErrorMessage} handleFormPrompt={handleFormPrompt} form={form} url={url}/>
});

class PinRetrievalPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: props.appState.ui.pinRetrieval.steps.totalSteps,
      attempts: 0,
      prompt: false,
      form: {}
    }

    this.handleErrorMessage = this.handleErrorMessage.bind(this);
    this.handleMultipleAttempts = this.handleMultipleAttempts.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.handleFormPrompt = this.handleFormPrompt.bind(this);
    this.backHandler = this.backHandler.bind(this);

    this.handleCardStatus = this.handleCardStatus.bind(this);
  };

  componentDidMount() {
    this.props.update({
      cardActivation: {
        activeStep: 1,
        error: {
          isVisible: false,
          message: ''
        }
      },
      pinRetrieval: {
        activeStep: this.props.appState.pinRetrieval.activeStep,
        error: {
          isVisible: false,
          message: ''
        }
      },
      loading: false
    });
    // SessionStorage.clearSessionStorage();
    SessionStorage.removeSessionStorageItem('bal');
    SessionStorage.removeSessionStorageItem('store');
  }

  handleFormPrompt = (form) => {
    this.setState({ form: form })
  }
  
  nextHandler = () => {
    if (this.props.appState.pinRetrieval.activeStep < this.state.steps) {
      this.props.update({
        pinRetrieval: {
          activeStep: this.props.appState.pinRetrieval.activeStep + 1,
          error: this.props.appState.pinRetrieval.error
        }
      });
    }
  };

  backHandler = () => {
    if (this.props.appState.pinRetrieval.activeStep === 2) {
      this.setState({
        prompt: true,
        form: false
      });
    } else {
      if (this.props.appState.code.length > 1) {
        this.props.history.push(this.generateURIFromCode(this.props.appState.code, ''))
      } else if (this.props.appState.route.schema !== undefined) {
        this.props.history.push(''+ this.generateURIFromCode(this.createSchemaAndClientCode(this.props.appState.route.schema, this.props.appState.route.client), ''));
      } else {
        this.props.history.goBack();
        // this.props.history.push(this.generateURIFromCode(this.props.appState.code, ''))
      }
    }
  };

  onCancel = () => {
    this.setState({prompt: false})
  };

  onConfirm = () => {
    this.setState({prompt: false, form: false})
    
    // this.props.update({
    //   pinRetrieval: {
    //     activeStep: this.props.appState.pinRetrieval.activeStep - 1,
    //     error: this.props.appState.pinRetrieval.error
    //   }
    // });

    if (this.props.appState.pinRetrieval.activeStep === 1) {
      this.props.history.goBack();
    } else {
      this.props.update({
        pinRetrieval: {
          activeStep: this.props.appState.pinRetrieval.activeStep - 1,
          error: this.props.appState.pinRetrieval.error
        }
      });
    }
  }

  createSchemaAndClientCode = (schema, client) => {
    let route = '';
    if (schema !== undefined) {
      route += schema.toLowerCase();
    }
    if (client !== undefined) {
      route += `_${client.toLowerCase()}`;
    }
    return route;
  }

  generateURIFromCode = (code, path) => {
    let uri = ''
    let url = code.toLowerCase().split('_');
    if (url[0] === 'default') {
      uri = `/${path}`;
      return uri
    }
    if (url[0] === '') {
      uri = `/${path}`;
      return uri
    }
    if (url[1] !== undefined && url[1].length > 1) {
      uri = `/${url[0]}/${url[1]}/${path}`;
      return uri
    } else {
      uri = `/${url[0]}/${path}`;
      return uri
    }
  }

  handleErrorMessage(isVisible, message, type) {
    this.props.update({
      pinRetrieval: {
        activeStep: this.props.appState.pinRetrieval.activeStep,
        error: {
          isVisible: isVisible,
          message: message,
          type: 'error'
        }
      }
    });
  }

  handleMultipleAttempts() {
    this.setState(prevState => {
      return { attempts: prevState.attempts + 1 };
    });
  }

  handleCardStatus(state, route, setSubmitting) {
    setSubmitting(false);
    switch (state.cardDetails.CardStatus) {
      case 'I': 
        this.handleFormPrompt(false);
        this.props.update({
          route: {
            schema: route.schema,
            client: route.client,
          },
          cardActivation: {
            activeStep: this.props.appState.cardActivation.activeStep,
            error: {
              message: "Your card is not activated yet. Please complete the details to activate your card and retrieve your PIN.",
              isVisible: true
            }
          },
          loading: false
        }, (state) => {
            this.props.history.push(this.generateURIFromCode(state.code, 'card-activation'))
        })
        break;
      case 'A':
        this.handleErrorMessage(false, '', 'error');
        // this.props.update({
        //   route: {
        //     schema: route.schema,
        //     client: route.client,
        //   },
        // }, (state) => {
          let eComponentData = {
            Email: 'noreply@edenred.com',
            CardSerialNumber: state.cardDetails.SerialNumber,
            EComponentConfigurationTemplateId: state.cardDetails.EComponentTemplateId === null ? 1 : state.cardDetails.EComponentTemplateId,
            CardStatus: state.cardDetails.CardStatus,
            ExtranetSiteRules: JSON.stringify(state.siteRules),
            Culture: 'en-gb'
          }
          this.props.api.getEComponentURL(eComponentData)
            .then(response => {
              this.props.update({
                route: {
                  schema: route.schema,
                  client: route.client,
                },
                eComponentURL: response
              }, () => {
                this.nextHandler();
                this.props.history.push(this.generateURIFromCode(state.code, 'pin-retrieval'))
              });
            })
            .catch(error => {
              this.handleErrorMessage(true, 'error getEComponentURL failed', 'error');
              // console.error('Status with getEComponentURL request', error)
              this.props.update({loading: false});
            });
        // })
        break;
      case 'E':
        this.handleErrorMessage(true, `Your card has unfortunately expired and can not be used.`, 'error');
        // console.error('CardStatus === ' + state.cardDetails.CardStatus);
        this.props.update({
          route: {
            schema: route.schema,
            client: route.client,
          },
          loading: false
        }, (state) => {
          this.props.history.push(this.generateURIFromCode(state.code, 'pin-retrieval'))
        })
        break;
      case 'B':
        this.handleErrorMessage(true, `Your card is currently blocked and therefore can not be used.`, 'error');
        // console.error('CardStatus === ' + state.cardDetails.CardStatus);
        this.props.update({
          route: {
            schema: route.schema,
            client: route.client,
          },
          loading: false
        }, (state) => {
          this.props.history.push(this.generateURIFromCode(state.code, 'pin-retrieval'))
        })
        break;
      case 'L':
        this.handleErrorMessage(true, `Your card has been reported as either damaged, stolen or lost and therefore cannot be used. Your case is under review if you have already contacted us and action will be taken accordingly shortly.`, 'error');
        // console.error('CardStatus === ' + state.cardDetails.CardStatus);
        this.props.update({
          route: {
            schema: route.schema,
            client: route.client,
          },
          loading: false
        }, (state) => {
          this.props.history.push(this.generateURIFromCode(state.code, 'pin-retrieval'))
        })
        break;
      case 'S':
        this.handleErrorMessage(true, `Your card has been reported as either damaged, stolen or lost and therefore cannot be used. Your case is under review if you have already contacted us and action will be taken accordingly shortly.`, 'error');
        // console.error('CardStatus === ' + state.cardDetails.CardStatus);
        this.props.update({
          route: {
            schema: route.schema,
            client: route.client,
          },
          loading: false
        }, (state) => {
          this.props.history.push(this.generateURIFromCode(state.code, 'pin-retrieval'))
        })
        break;
      case 'D':
        this.handleErrorMessage(true, `Your card has been reported as either damaged, stolen or lost and therefore cannot be used. Your case is under review if you have already contacted us and action will be taken accordingly shortly.`, 'error');
        // console.error('CardStatus === ' + state.cardDetails.CardStatus);
        this.props.update({
          route: {
            schema: route.schema,
            client: route.client,
          },
          loading: false
        }, (state) => {
          this.props.history.push(this.generateURIFromCode(state.code, 'pin-retrieval'))
        })
        break;

      default:
      this.handleErrorMessage(true, `Unhandled CardStatus === ${state.cardDetails.CardStatus}`, 'error');
        // console.error('Unhandled CardStatus === ' + state.cardDetails.CardStatus);
        this.props.update({
          route: {
            schema: route.schema,
            client: route.client,
          },
          loading: false
        }, (state) => {
          this.props.history.push(this.generateURIFromCode(state.code, 'pin-retrieval'))
        })
    }
  }

  render() {
    return (
      <Fragment>

        <Helmet>
          <title>{this.props.appState.ui.pinRetrieval.meta.title}</title>
          <meta name="description" content={this.props.appState.ui.pinRetrieval.meta.description} />
        </Helmet>
      
        <Header header={this.props.appState.ui.header} url={this.props.url}/>
        
        <Main site={this.props.appState.ui.site} >
          <Card card={this.props.appState.ui.pinRetrieval.card} nextHandler={this.nextHandler} backHandler={this.backHandler}>

          <Error isVisible={this.props.appState.pinRetrieval.error.isVisible} message={this.props.appState.pinRetrieval.error.message} />

          <ProgressSteps steps={this.props.appState.ui.pinRetrieval.steps} step={this.props.appState.pinRetrieval.activeStep} />

          {getStepHandler(
            this.nextHandler, 
            this.backHandler,
            this.props.appState,
            this.props.api,
            this.props.update,
            this.props.history,
            this.props.validateCodeAndStoreSettings,
            this.props.validateCodeAndReturnRoute,
            this.generateURIFromCode,
            this.handleErrorMessage,
            this.handleMultipleAttempts,
            this.state.attempts,
            this.handleFormPrompt,
            this.state.form,
            this.handleCardStatus,
            this.props.url)[this.props.appState.pinRetrieval.activeStep]}
          </Card>
        </Main>

        <Footer footer={this.props.appState.ui.footer} url={this.props.url} clientTerms={this.props.appState.ui.clientTerms} />

        <Dialog when={this.state.prompt} onCancel={this.onCancel} onConfirm={this.onConfirm} message={`Are you sure you want to exit?`} ui={this.props.appState.ui}/>
  
        {this.state.form === true
        ?
          <NavigationPrompt when={this.state.form}>
            {({onConfirm, onCancel}) => (
              <Dialog when={true} onCancel={onCancel} onConfirm={this.onConfirm} message={`Are you sure you want to exit?`} ui={this.props.appState.ui}/>
            )}
          </NavigationPrompt>
        :
          null
        }

      </Fragment>
    );
  };
};

export default withRouter(PinRetrievalPage);


// WEBPACK FOOTER //
// ./src/containers/PinRetrievalPage/PinRetrievalPage.js